<div class="card card-dark mb-5">
    <div class="card-header" *ngIf="showFilter">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group mb-0">
                    <select class="custom-select" id="InputSearchTipoProducto" name="InputSearchTipoProducto"
                        (change)="updateFilter($event, 1);">
                        <option value="-1">Todo</option>
                        <option *ngFor="let item of tipoProductos" value="{{item.id_tipoproducto}}">
                            {{item.nombre_tipoproducto}}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-8">
                <div class="form-group mb-0">
                    <div class="input-group">
                        <input class="form-control" id="inputSearch" name="inputSearch" type="text" placeholder="Search"
                            aria-label="Search" autocomplete="off" (keyup)="updateFilter($event, 2)">
                        <div class="input-group-append">
                            <span class="input-group-text bg-info"><i class="fas fa-search"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ngx-datatable #table class='bootstrap black' [columnMode]="'flex'" [headerHeight]="50" [footerHeight]="50"
        [rowHeight]="'auto'" [limit]="10" [rows]='rows' [messages]="messages">

        <!-- Row Panel Template -->
        <!-- <ngx-datatable-row-detail [rowHeight]="100" #myDetailRow>
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            <div>
                TEST TEST
            </div>
        </ng-template>
    </ngx-datatable-row-detail> -->

        <!-- Column: Open Panel-->
        <!--     <ngx-datatable-column [flexGrow]="0.8" [width]="50" [resizeable]="false" [sortable]="false" [draggable]="false"
        [canAutoResize]="false">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <a class="table-icons" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded"
                title="Expand/Collapse Row" (click)="toggleExpandRow(row, expanded)">
            </a>
        </ng-template>
    </ngx-datatable-column> -->

        <!-- Other Columns -->

        <ngx-datatable-column [flexGrow]="1" name="Habilitado" prop="habilitado">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                <i *ngIf="row.habilitado == 1" class="fas fa-eye text-success"></i>
                <i *ngIf="row.habilitado == 0" class="fas fa-eye-slash text-danger"></i>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [flexGrow]="1.5" name="Tipo" prop="tipo_producto.nombre_tipoproducto">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                <span>{{row.tipo_producto.nombre_tipoproducto}}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [flexGrow]="2.5" name="Nombre" prop="nombre">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                <span>{{row.nombre}}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [flexGrow]="1.5" name="Procesamiento" prop="procesamiento">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                <select class="custom-select" id="InputProcesamiento" name="InputProcesamiento"
                    [(ngModel)]="row.procesamiento" *ngIf="isEditable[rowIndex]">
                    <option value="24">24h</option>
                    <option value="48">48h</option>
                    <option value="72">72h</option>
                    <option value="96">96h</option>
                    <option value="120">120h</option>
                    <option value="144">144h</option>
                </select>
                <span *ngIf="!isEditable[rowIndex]">{{row.procesamiento}}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [flexGrow]="1.3" name="Valor" prop="valor">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                <input class="form-control" value="valor" [(ngModel)]="row.valor" [disabled]="!isEditable[rowIndex]"
                    *ngIf="isEditable[rowIndex]">
                <span *ngIf="!isEditable[rowIndex]">{{Func.currencyPeso(row.valor)}}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [flexGrow]="1.3" name="Costo" prop="costo">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                <input class="form-control" value="costo" [(ngModel)]="row.costo" [disabled]="!isEditable[rowIndex]"
                    *ngIf="isEditable[rowIndex]">
                <span *ngIf="!isEditable[rowIndex]">{{Func.currencyPeso(row.costo)}}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [flexGrow]="1.3" name="Stock" prop="stock">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                <span>{{row.stock}}</span>
            </ng-template>
        </ngx-datatable-column>


        <!-- Column: Editing Mode-->
        <ngx-datatable-column [flexGrow]="1" [sortable]="false">
            <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                <!-- Pencil icon -->
                <button type="button" class="btn btn-outline-info btn-sm" *ngIf="!this.isEditable[rowIndex]"
                    (click)="this.isEditable[rowIndex]=!this.isEditable[rowIndex]">
                    <i class="fas fa-pen" title="Modify"></i>
                </button>

                <!-- Save/Delete icons -->
                <div class="btn-group" *ngIf="showDelete">
                    <button type="button" class="btn btn-outline-success btn-sm" *ngIf="this.isEditable[rowIndex]" title="Guardar"
                        (click)="save(row, rowIndex);">
                        <i class="fas fa-save"></i>
                    </button>
                    <button type="button" class="btn btn-outline-danger btn-sm" *ngIf="this.isEditable[rowIndex] && row.habilitado == 1" title="DesHabilitar"
                        (click)="delete(row,rowIndex)">
                        <i class="fas fa-eye-slash"></i>
                    </button>
                    <button type="button" class="btn btn-outline-warning btn-sm" *ngIf="this.isEditable[rowIndex] && row.habilitado == 0" title="Habilitar"
                        (click)="delete(row,rowIndex)">
                        <i class="fas fa-eye"></i>
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="this.isEditable[rowIndex]" title="Cancelar"
                        (click)="this.isEditable[rowIndex] = !this.isEditable[rowIndex]">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="btn-group" *ngIf="!showDelete">
                    <button type="button" class="btn btn-outline-success btn-sm" *ngIf="this.isEditable[rowIndex]" title="Guardar"
                        (click)="save(row, rowIndex);">
                        <i class="fas fa-save"></i>
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="this.isEditable[rowIndex]" title="Cancelar"
                        (click)="this.isEditable[rowIndex] = !this.isEditable[rowIndex]">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

    </ngx-datatable>
</div>